import React, {
  createContext, useContext, useState, useEffect
} from 'react';

import { env } from 'Constants';
import { useRouter } from 'Context/hooks';
import { useUser } from 'Context/user';
import * as Resources from 'Services/resources/resource';

const NavContext = createContext();

export const NavContextProvider = (props) => {
  const { pathname } = useRouter();
  const { setUserWatchViewSearch } = useUser();
  const [titleOverwrite, setTitleOverwrite] = useState();
  const [resetClock, setResetClock] = useState(false);
  const [versionOutdated, setVersionOutdated] = useState();

  useEffect(() => {
    const currentVersion = env.REACT_APP_VERSION;

    const interval = setInterval(() => {
      Resources.get('latest_portal_version', '').then(({ portal_version_id: latestVersion }) => {
        setVersionOutdated(currentVersion !== latestVersion);
      });
    }, 1000 * 60 * 5);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!pathname.includes('watch')) {
      setUserWatchViewSearch(undefined);
    }
  }, [pathname, setUserWatchViewSearch]);

  return (
    <NavContext.Provider
      value={{
        titleOverwrite,
        setTitleOverwrite,
        resetClock,
        setResetClock,
        versionOutdated,
      }}
      {...props}
    />
  );
};

export const useNavContext = () => useContext(NavContext);
